// FAQ page search — filters the <details> rows rendered by
// sections/dc-faq.liquid based on the search box in
// sections/dc-faq-banner.liquid. The two sections are wired together only by
// shared element ids/data-attributes (not a direct reference), since either
// section can render first and either can be removed independently in the
// theme editor.
function initDcFaqSearch() {
  const input = document.getElementById("dc-faq-search-input");
  const clearButton = document.getElementById("dc-faq-search-clear");
  const items = document.querySelectorAll("[data-dc-faq-item]");
  const emptyState = document.querySelector("[data-dc-faq-empty]");
  if (!input || !items.length) return;

  function applyFilter() {
    const query = input.value.trim().toLowerCase();
    let visibleCount = 0;

    items.forEach((item) => {
      const question = (item.dataset.dcFaqQuestion || "").toLowerCase();
      const matches = query === "" || question.includes(query);
      item.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    if (clearButton) clearButton.hidden = query === "";
    if (emptyState) emptyState.hidden = visibleCount > 0;
  }

  input.addEventListener("input", applyFilter);

  if (clearButton) {
    clearButton.addEventListener("click", () => {
      input.value = "";
      applyFilter();
      input.focus();
    });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initDcFaqSearch);
} else {
  initDcFaqSearch();
}
